import request from './index'

export function login(data) {
  return request.post('/auth/login.php', {
    account: data.account,
    password: data.password
  })
}

export function register(data) {
  return request.post('/auth/register.php', {
    username: data.username,
    email: data.email,
    password: data.password
  })
}

/** 发起微信扫码登录会话 */
export function startWechatLogin() {
  return request.post('/auth/wechat-login.php', {})
}

/** 轮询微信扫码登录状态（成功时服务端签发 Cookie） */
export function pollWechatLogin(sid, token) {
  return request.get('/auth/wechat-login.php', {
    params: { sid, token }
  })
}

export function logout() {
  return request.post('/auth/logout.php')
}

export function fetchMe() {
  return request.get('/auth/me.php')
}
